export default __webpack_public_path__ + "c7cbdef4ed22d03618724e93089e62be.png";